export var AddressInfoCodesMessages = [{
  "2000": "Unable to identify city, region, and/or postcode information."
}, {
  "2020": "Unable to identify postcode, and invalid city is preventing address cleansing."
}, {
  "2030": "Invalid city and postcode are preventing address cleansing."
}, {
  "2040": "Invalid postcode is preventing a city selection"
}, {
  "2050": "City, region, and postcode matches are too close to choose one."
}, {
  "2070": "City is valid, but multiple possible postcodes prevent choosing one."
}, {
  "3000": "City, region, and postcode are valid, but unable to identify the street address."
}, {
  "3010": "City, region, and postcode are valid, but unable to match street name to directory."
}, {
  "3020": "Possible street name matches are too close to choose one."
}, {
  "3030": "House number is missing on input or not in the directory."
}, {
  "3050": "An invalid or missing street type is preventing address cleansing."
}, {
  "3060": "A missing street type and prefix/suffix is preventing address cleansing."
}, {
  "3070": "An invalid or missing prefix/suffix is preventing address cleansing."
}, {
  "3080": "An invalid or missing postcode is preventing address cleansing."
}, {
  "3090": "An invalid or missing city is preventing address cleansing."
}, {
  "3100": "Possible address matches are too close to choose one."
}, {
  "3200": "The building is missing on input or not in the directory."
}, {
  "3210": "The building's address is not in the directory."
}, {
  "3220": "Possible building matches are too close to choose one."
}, {
  "3250": "The house number or building is missing on input or both are not in the directory."
}, {
  "3300": "The postcode-only lookup returned multiple street names."
}];